import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from "../../context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import Table from '../../components/Table';
import { Link } from 'react-router-dom';
import { CatoColumns } from "../../components/headerContent";
import CatoStory from './CatoStory';
import CatoOverview from './CatoOverview';
import Loader from "../../components/Loader";
import { useTranslation } from "react-i18next";

export default function Cato() {
    const { apiUrl } = useContext(AuthContext);
    const [statusCounts, setStatusCounts] = useState({
        Open: 0,
        Progress: 0,
        Closed: 0,
        Reopened: 0,
    });
    const [criticalityCounts, setCriticalityCounts] = useState({
        low: 0,
        medium: 0,
        high: 0,
    });
    const [link, setLink] = useState(null);
    const { t } = useTranslation();

    const getStories = async () => {
        const res = await axios(`${apiUrl}cato/stories`, {
            method: "get",
            withCredentials: true
        });

        return res.data;
    };

    const stories = useQuery({
        queryKey: ["stories"],
        queryFn: getStories
    });

    useEffect(() => {
        if (stories.data?.stories) {
            const statusCounter = {
                Open: 0,
                Progress: 0,
                Closed: 0,
                Reopened: 0,
            };

            const criticalityCounter = {
                low: 0,
                medium: 0,
                high: 0,
                total: 0
            };

            stories.data.stories.forEach((story) => {
                const status = story.status || 'Unknown';
                statusCounter[status] = (statusCounter[status] || 0) + 1;

                const c = story.criticality;
                if (c >= 1 && c <= 3) criticalityCounter.low += 1;
                else if (c >= 4 && c <= 6) criticalityCounter.medium += 1;
                else if (c >= 7 && c <= 10) criticalityCounter.high += 1;
                criticalityCounter.total = criticalityCounter.low + criticalityCounter.medium + criticalityCounter.high;
            });

            setStatusCounts(statusCounter);
            setCriticalityCounts(criticalityCounter);
        }
    }, [stories.data]);

    if (!stories.isLoading && !stories.data) {
        return (
            <div className="ecp-container">
                <div className="ecp-container-content-error">
                    <div className="error-container">
                        <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
                        <div className="error-container-text">
                            <h1 className="page-title">
                                {t("Service actuellement indisponible")}
                            </h1>
                            <p className="page-link_home">
                                <Link to="/"> {t("Revenir à l'accueil")}</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {!stories.isLoading && stories.data ? (
                <article className="page page-cato">
                    <div className='cato'>
                        {!link ? (
                            <>
                                <img className='logo_cato' src='./assets/cato_logo.svg' alt="logo cato" />
                                <section className='cato-header'>
                                    <div className='cato-header-type-stories'>
                                        <h2 className='cato-header-type-title'>{t("Total Stories")}</h2>
                                        <div className='cato-header-type-content'>
                                            <h2 className='cato-header-type-second-title'>{criticalityCounts.total}</h2>
                                            <div className='cato-header-type-content'>{t("Criticality")}</div>
                                        </div>
                                        <div className='cato-header-type-graph'>
                                            <div
                                                className='bar-segment low'
                                                style={{ width: `${criticalityCounts.total ? (criticalityCounts.low / criticalityCounts.total) * 100 : 0}%` }}
                                            />
                                            <div
                                                className='bar-segment medium'
                                                style={{ width: `${criticalityCounts.total ? (criticalityCounts.medium / criticalityCounts.total) * 100 : 0}%` }}
                                            />
                                            <div
                                                className='bar-segment high'
                                                style={{ width: `${criticalityCounts.total ? (criticalityCounts.high / criticalityCounts.total) * 100 : 0}%` }}
                                            />
                                        </div>
                                    </div>
                                    <div className='cato-header-type-status'>
                                        <h2 className='cato-header-type-title'>{t("Stories Status")}</h2>
                                        <div className='cato-header-type-status-content'>
                                            <div className='cato-header-type-status-content-items'>
                                                <div className='cato-header-type-status-content-items-icon'>
                                                    <FontAwesomeIcon icon={faCircleCheck} color={'#AEC353'} />
                                                </div>
                                                <h2 className='cato-header-type-second-title'>{statusCounts.Open}</h2>
                                                <div className='cato-header-type-content'>{t("Open")}</div>
                                            </div>
                                            <div className='cato-header-type-status-content-items'>
                                                <div className='cato-header-type-status-content-items-icon'>
                                                    <img src='./assets/icon-progress.svg' alt="icône de progression" />
                                                </div>
                                                <h2 className='cato-header-type-second-title'>{statusCounts.Progress}</h2>
                                                <div className='cato-header-type-content'>{t("In Progress")}</div>
                                            </div>
                                            <div className='cato-header-type-status-content-items'>
                                                <div className='cato-header-type-status-content-items-icon'>
                                                    <FontAwesomeIcon icon={faCircleXmark} color={'red'} />
                                                </div>
                                                <h2 className='cato-header-type-second-title'>{statusCounts.Closed}</h2>
                                                <div className='cato-header-type-content'>{t("Closed")}</div>
                                            </div>
                                            <div className='cato-header-type-status-content-items'>
                                                <div className='cato-header-type-status-content-items-icon'>
                                                    <img src='./assets/icon-reload.svg' alt="icône de reload" />
                                                </div>
                                                <h2 className='cato-header-type-second-title'>{statusCounts.Reopened}</h2>
                                                <div className='cato-header-type-content'>{t("Reopened")}</div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <section className='cato-content'>
                                    <div className='cato-content-table'>
                                        <Table tableData={stories.data.stories} tableColumns={CatoColumns} setLink={setLink} />
                                    </div>
                                </section>
                                <CatoOverview />
                            </>
                        ) : (
                            <CatoStory storyId={link} setLink={setLink} />
                        )}
                    </div>
                </article>
            ) : (
                <Loader />
            )}
        </>
    );
};
